import { createContext, useContext } from 'react';

export const SlotContext = createContext({
  headerId: '',
  footerId: '',
  titleId: '',
  descriptionId: '',
  compact: false,
});
export const useSlots = () => useContext(SlotContext);
